<div class="loading-block" *ngIf="!title && !value">
    <svg-image name="total-spinner"></svg-image>
</div>

<div class="header">
    <svg-image name="question-help" class="help-icon" [tooltip]="tooltipText"></svg-image>
    <span>{{ title | i18next }}</span>
    <div class="footer--desktop">
        <ng-container [ngTemplateOutlet]="footer"></ng-container>
    </div>
</div>
<div class="main">
    <ng-container *ngIf="complex; else singleValue">
        <div class="value-wrapper" *ngFor="let subTitle of subTitles; index as i">
            <div class="sub-title">{{ subTitle }}</div>

            <div class="value">
                {{ value[i] }}
            </div>
        </div>
    </ng-container>

    <ng-template #singleValue>
        {{ value }}
    </ng-template>
    <div class="footer--mobile">
        <ng-container [ngTemplateOutlet]="footer"></ng-container>
    </div>
</div>
<ng-template #footer>
    <div class="footer">
        <ng-container *ngIf="isArray(percent); else singlePercentValue">
            <div
                class="percent-wrapper"
                [class.negative]="negative[i]"
                [tooltip]="relatedDate"
                *ngFor="let percentValue of percent; index as i"
            >
                {{ percentValue }}
                <svg-image [name]="arrowName(negative[i])" class="direction-arrow"></svg-image>
            </div>
        </ng-container>

        <ng-template #singlePercentValue>
            <div class="percent-wrapper" [tooltip]="relatedDate" [class.negative]="negative">
                {{ percent }}
                <svg-image [name]="arrowName(negative)" class="direction-arrow"></svg-image>
            </div>
        </ng-template>
    </div>
</ng-template>
